import { defineStore } from 'pinia'
import { fetchWrapper } from '../helpers'
import router from '../router'

const baseUrl = `${import.meta.env.VITE_API_URL}`

export const useAuthStore = defineStore('auth', {
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    user: JSON.parse(<string>localStorage.getItem('user')),
    userMeta: JSON.parse(<string>localStorage.getItem('userMeta')),
    returnUrl: null,
    host: localStorage.getItem('CourstoreHost'),
  }),
  actions: {
    async login(login: string, password: string, host: string) {
      const user = await fetchWrapper.post(`${baseUrl}/login`, {
        login,
        password,
      })
      this.user = user
      this.host = host
      // store user details and jwt in local storage to keep user logged in between page refreshes
      localStorage.setItem('user', JSON.stringify(user))
      // redirect to previous url or default to home page
      this.me().then((userMeta) => {
        this.userMeta = userMeta
        localStorage.setItem('userMeta', JSON.stringify(userMeta))
      })
      localStorage.setItem('CourstoreHost', host)

      await router.push(this.returnUrl || '/main')
    },

    async me() {
      return await fetchWrapper.post(`${baseUrl}/me`, {})
    },

    logout() {
      this.user = null
      localStorage.removeItem('user')
      localStorage.removeItem('userMeta')
      localStorage.removeItem('CourstoreHost')
      router.push('/login')
    },
  },
})
